export enum EPreferredContactEnum {
    Email = 0,
    SMS = 1,
    Voice = 2
}